// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3DXFl","control":"Checkout_control__xKsof","actions":"Checkout_actions__2k5D-","submit":"Checkout_submit__2B6UI","invalid":"Checkout_invalid__3S0cO"};